module.exports = __webpack_public_path__ + "media/showcase.4d7efd31.mp4";